import NoHeaderAgGridSkeleton from '@/app/common/components/skeleton/NoHeaderAgGridSkeleton';
import { Accordion, Table } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { useGetByUrlQuery } from '@/app/Crawl/api/detailsApi';
import SubtleBadge from '@/components/common/SubtleBadge';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';
// موارد مربوط به چگالی در جزییات صفحه
const Density = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  const { data: rawData, isLoading } = useGetByUrlQuery({
    job_page: searchParams.get('job_page'),
    domain_slug,
    page_url: decoder(searchParams.get('page_url') as string),
    type: 'internal',
    columns: ['density_words_1', 'density_words_2', 'density_words_3']
  });
  const data = rawData as {
    data?: {
      density_words_1: string[] | number;
      density_words_2: string[] | number;
      density_words_3: string[] | number;
    };
  };
  const words = (value: string[] | number | undefined): string[] =>
    Array.isArray(value) ? value : [];

  return (
    <div id="density" className="mt-5">
      <Accordion defaultActiveKey={['0', '1', '2']} alwaysOpen>
        <Accordion.Item eventKey="0">
          {/* جدول چگالی 1 کلمه */}
          <Accordion.Header>چگالی تک کلمه</Accordion.Header>
          <Accordion.Body>
            {!isLoading ? (
              <Table>
                <tbody>
                  <tr>
                    <td>
                      {data?.data?.density_words_1 !== 0 ? (
                        <ul className="p-0">
                          {words(data?.data?.density_words_1).map(
                            (item: string, index: number) => (
                            <li key={index} className="mb-1">
                              {item}
                            </li>
                            )
                          )}
                        </ul>
                      ) : (
                        <SubtleBadge bg="warning" className="me-2">
                          ندارد
                        </SubtleBadge>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <NoHeaderAgGridSkeleton height="289px" />
            )}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          {/* جدول چگالی 2 کلمه */}
          <Accordion.Header>چگالی دو کلمه</Accordion.Header>
          <Accordion.Body>
            {!isLoading ? (
              <Table>
                <tbody>
                  <tr>
                    <td>
                      {data?.data?.density_words_2 !== 0 ? (
                        <ul className="p-0">
                          {words(data?.data?.density_words_2).map(
                            (item: string, index: number) => (
                            <li key={index} className="mb-1">
                              {item}
                            </li>
                            )
                          )}
                        </ul>
                      ) : (
                        <SubtleBadge bg="warning" className="me-2">
                          ندارد
                        </SubtleBadge>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <NoHeaderAgGridSkeleton height="289px" />
            )}
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          {/* جدول چگالی 3 کلمه */}
          <Accordion.Header>چگالی سه کلمه</Accordion.Header>
          <Accordion.Body>
            {!isLoading ? (
              <Table>
                <tbody>
                  <tr>
                    <td>
                      {data?.data?.density_words_3 !== 0 ? (
                        <ul className="p-0">
                        {words(data?.data?.density_words_3).map(
                            (item: string, index: number) => (
                            <li key={index} className="mb-1">
                              {item}
                            </li>
                            )
                          )}
                        </ul>
                      ) : (
                        <SubtleBadge bg="warning" className="me-2">
                          ندارد
                        </SubtleBadge>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <NoHeaderAgGridSkeleton height="289px" />
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Density;
